/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Precheck_AbortInputs */

const en_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abort`)
};

const fr_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner`)
};

const de_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aborto`)
};

const ru_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

const zh_cn2_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

const ja_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アボート`)
};

const hi_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीच में बंद करें`)
};

const pt_pt2_dialogue_list_export_precheck_abort = /** @type {(inputs: Dialogue_List_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Dialogue_List_Export_Precheck_AbortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_precheck_abort = /** @type {((inputs?: Dialogue_List_Export_Precheck_AbortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Precheck_AbortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_precheck_abort(inputs)
	if (locale === "de") return de_dialogue_list_export_precheck_abort(inputs)
	if (locale === "it") return it_dialogue_list_export_precheck_abort(inputs)
	if (locale === "ru") return ru_dialogue_list_export_precheck_abort(inputs)
	if (locale === "es") return es_dialogue_list_export_precheck_abort(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_precheck_abort(inputs)
	if (locale === "ja") return ja_dialogue_list_export_precheck_abort(inputs)
	if (locale === "hi") return hi_dialogue_list_export_precheck_abort(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_precheck_abort(inputs)
	return en_dialogue_list_export_precheck_abort(inputs)
});